// extracted by mini-css-extract-plugin
export default {"container":"style_container__WseMq","information":"style_information__qFnPp","infoContractType":"style_infoContractType__Qsg9v"};